import {
  EXERCISE_CLASS_NAME,
  MODEL_KEY
} from '@gymaholic/packages'

import ComponentLoader from 'components/ComponentLoader'
import { View } from 'components/View.js'
import { MOTIVATION_MODEL_CLASS_NAME } from 'models/daos/motivation/constants'
import { PRODUCT_MODEL_CLASS_NAME } from 'models/daos/product/constants'
import { STYLES_LAZY_LOAD_DEFAULT_ELEMENT_HEIGHT } from 'modules/styles/constants/index.cjs'
import { TRAINING_PLAN_CLASS_NAME } from 'modules/training/models/plan/constants'
import { WORKOUT_CLASS_NAME } from 'modules/training/models/workout/constants'
import React from 'react'
import LazyLoad from 'react-lazyload'
import { logUtil } from 'packages/src'

const CONTENT_OBJECT_CLASS_NAME_TO_COMPONENT_LOADER_PROMISE = {
  TrainingDocument: () => {
    return import('pages/Article/Content/components/TrainingDocument')
  },
  [PRODUCT_MODEL_CLASS_NAME]: () => {
    return import('pages/Article/Content/components/Product')
  },
  TrainingExerciseVideo: () => {
    return import('pages/Article/Content/components/TrainingExerciseVideo')
  },
  [EXERCISE_CLASS_NAME]: () => {
    return import('pages/Article/Content/components/ExerciseVideo')
  },
  [TRAINING_PLAN_CLASS_NAME]: () => {
    return import('pages/Article/Content/components/TrainingPlan')
  },
  [WORKOUT_CLASS_NAME]: () => {
    return import('pages/Article/Content/components/Workout')
  },
  [MOTIVATION_MODEL_CLASS_NAME]: () => {
    return import('pages/Article/Content/components/Motivation')
  }
}

/**
 * @param props
 * @param props.contentObject
 * @return {React.JSX.Element}
 * @constructor
 */
export function ArticleContentObject (props) {
  const { contentObject } = props

  const className = contentObject[MODEL_KEY.CLASS_NAME]
  const componentLoader = (
    CONTENT_OBJECT_CLASS_NAME_TO_COMPONENT_LOADER_PROMISE[className]
  )

  if (!componentLoader) {
    logUtil('ArticleContentObject').warn('loader not found contentObject=', contentObject)
    return <></>
  }

  return (
    <LazyLoad
      height={STYLES_LAZY_LOAD_DEFAULT_ELEMENT_HEIGHT}
      offset={-1}
    >
      <View mt>
        <ComponentLoader
          loadComponent={componentLoader}
          isClickable
          shouldLoad
          {...contentObject}
        />
      </View>
    </LazyLoad>
  )
}
